import { DefaultEntity } from '@/types';
import APIService from './axios.service';
import { BaseService } from './base.service';

class AuthServiceClass extends BaseService<
  'profile',
  DefaultEntity,
  DefaultEntity
> {
  constructor() {
    super('auth');
  }

  setAcceptTermsOfService = (payload: {
    userId: string;
    tenantId: string;
  }): Promise<void> => {
    const { userId, tenantId } = payload;
    return APIService.post(
      this.path + '/accept-terms-of-service',
      { userId },
      {
        params: { tenantId },
      },
    );
  };
}

export const authService = new AuthServiceClass();
